import { motion } from "framer-motion";
import { CONTACT } from "@/constants/testIds";

export const Contact = () => {
  return (
    <section id="contact" data-testid={CONTACT.root} className="py-24 md:py-32 bg-ink text-bone">
      <div className="max-w-[1100px] mx-auto px-6 md:px-12 lg:px-20 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <p className="eyebrow mb-6" style={{ color: "#D4A373" }}>
            Get in touch
          </p>
          <h2 className="font-serif text-5xl md:text-7xl leading-[1.02]">
            Let&apos;s build
            <br />
            <span className="italic text-clay">something quiet.</span>
          </h2>
          <p className="mt-8 text-bone/70 max-w-md mx-auto leading-relaxed">
            Hiring, subcontracting, or just want to talk shop? Reach out
            directly — I read every message personally and reply within two
            business days.
          </p>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-10 max-w-3xl mx-auto">
            <div>
              <p className="eyebrow mb-2" style={{ color: "#D4A373" }}>
                Email
              </p>
              <a
                href="mailto:Lei.jtab@gmail.com"
                className="font-serif text-2xl link-underline break-all"
              >
                Lei.jtab@gmail.com
              </a>
            </div>
            <div>
              <p className="eyebrow mb-2" style={{ color: "#D4A373" }}>
                Phone
              </p>
              <a
                href="tel:+15878396507"
                className="font-serif text-2xl link-underline"
              >
                587-839-6507
              </a>
            </div>
            <div>
              <p className="eyebrow mb-2" style={{ color: "#D4A373" }}>
                Based in
              </p>
              <p className="font-serif text-2xl">Calgary, AB</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
